import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeRouteName: ''
  },
  mutations: {
    setActiveRouteName (state, activeRouteName) {
      state.activeRouteName = activeRouteName
    }
  },
  actions: {
  },
  modules: {
  }
})
